/* 
Pantalla de regalos compuesta por 2 componentes principales (FilterItem,GridCardItem)
*/

import React, { useState, useEffect } from "react";

import { GETTOKEN } from '../constants';

//REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  getListGiftAction
} from "../redux/actions/giftActions";

//MODULES
import { FilterItem, GridCardItem } from "ilusiona-react-components";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    marginBottom: "30px",
    display: "flex"
  }
}));
//#endregion

export default function ListGift(props) {
  const classes = useStyles();

  //Move camera top
  const comp = document.querySelector("#root").offsetTop - 100;
  window.scroll({ behavior: "smooth", top: comp });

  //#region Values
  const user = useSelector(state => state.user.user);
  const isMobile = useMediaQuery("(max-width:500px)");
  const [filter, setFilter] = useState({
    name: "",
    family: "",
    idCenter: user.idCenter,
    points: [user.points + 1, 100000]
  });
  const [pagination, setPagination] = useState({
    page: 0,
    rowsForPage: 24,
    listNumRows: [24, 36, 48, 60],
    order: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  //#endregion

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const listGifts = useSelector(state => state.gift.listGift);
  const numOfGift = useSelector(state => state.gift.numOfGift);
  const getListGift = (filter, from, to, order) =>
    dispatch(getListGiftAction(filter, from, to, order));
  //#endregion

  //Estar pendientes en cambios en el filtro
  useEffect(() => {
    if (pagination.page === 0) {
      setLoading(true);
      getListGift(filter, 0, pagination.rowsForPage, pagination.order)
        .then(v => {
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          setError(true);
        });
    } else {
      setPagination({ ...pagination, page: 0 });
    }
    // eslint-disable-next-line
  }, [filter]);

  //Estar pendientes de cambios en la paginación
  useEffect(() => {
    setLoading(true);

    getListGift(
      filter,
      pagination.page * pagination.rowsForPage,
      pagination.rowsForPage,
      pagination.order
    )
      .then(value => {
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setError(true);
      });
    // eslint-disable-next-line
  }, [pagination.page, pagination.rowsForPage, pagination.order]);

  return (
    <div className={classes.root}>
      <Grid container justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid
            container
            justify="flex-start"
            alignItems="flex-start"
            spacing={3}
            item
            xs={12}
          >
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography color="primary" variant="h4" data-lang="gift_title">
                  Lista de regalos
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FilterItem
                filter={filter}
                setFilter={setFilter}
                token={GETTOKEN()}
                options={{ isWeb: true }}
              />
            </Grid>
            <Grid item xs={12} md={9} lg={9}>
              <GridCardItem
                pagination={pagination}
                setPagination={setPagination}
                loading={loading}
                error={error}
                listItems={listGifts}
                numOfItem={numOfGift}
                options={{ isMobile: isMobile, isWeb: true }}
                onClick={() => console.log("click")}
              />
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}
